import { ActionBase } from '../../../core/store/action/ActionBase';

export const ACTIVATE_DRAFT_MESSAGE_TO_USERS_ACTION = '[Configuration] Activate Draft Message to Users';

export class ActivateDraftMessageToUsersAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = ACTIVATE_DRAFT_MESSAGE_TO_USERS_ACTION;
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/ActivateDraftMessageToUsersAction.ts